import DeepLinkAPIs from './DeepLink';
const WebModuleAPIs = {
    DeepLink: DeepLinkAPIs,
};
export default WebModuleAPIs;
